import { Button } from "ui";
import Icon from "components/icon";
import { Link } from "react-router-dom";
import { EDIT } from "icons";
import React from "react";
import classNames from "classnames";

const UpdateItemButton = ({ children, href, disabled = false, ...props }) => {

  if (href) {
    return (
      <Link
        to={href?.length ? href : "edit"}
        className={classNames({ "pointer-events-none": disabled })}
      >
        <Button {...props} disabled={disabled} className="flex items-center">
          <Icon icon={EDIT} /> {children ? children :"Edit"}
        </Button>
      </Link>
    );
  }
  return (
    <Button {...props} disabled={disabled} className="flex items-center">
      <Icon icon={EDIT} /> {children ? children :"Edit"}
    </Button>
  );
};

export default UpdateItemButton;
